/**
 * Servicio que se encarga del manejo de las peticiones sobre las PQR.
 * JMM-2018-07-09
 */
import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service';
//Declaracion de variable global para usar jQuery
declare var $: any;

@Injectable()
export class PqrService {
  language = {
    lengthMenu: "Mostrar _MENU_ registros por página.",
    zeroRecords: "No se ha encontrado ningún registro.",
    info: "Mostrando _START_ a _END_ de _TOTAL_ entradas.",
    infoEmpty: "Registros no disponibles.",
    search   : "",
    searchPlaceholder: "Buscar",
    loadingRecords: "Cargando...",
    processing:     "Procesando...",
    paginate: {
      first:      "Primero",
      last:       "Último",
      next:       "Siguiente",
      previous:   "Anterior"
    },
    infoFiltered: "(_MAX_ Registros filtrados en total)"
  }

  buttons: [
    { extend: 'colvis', text : 'Visualización columnas', columns: ':not(.noVis)'},
    {
      extend: 'copy', className: 'copyButton', text: 'Copiar',
      title: 'Informe Costo Proveedor',
      exportOptions: {
        columns: [':visible :not(:first-child)']
      }
    },
    {
      extend: 'csv', className: 'csvButton', text: 'CSV',
      title: 'Informe Costo Proveedor',
      exportOptions: {
        columns: [':visible :not(:first-child)']
      }
    },
    {
      extend: 'excel', className: 'excelButton', text: 'Excel',
      title: 'Informe Costo Proveedor',
      exportOptions: {
        columns: [':visible :not(:first-child)']
      }
    },
    {
      extend: 'pdf', className: 'pdfButton', tex: 'PDF',
      title: 'Informe Costo Proveedor',
      exportOptions: {
        columns: [':visible :not(:first-child)']
      }
    },
    {
      extend: 'print', className: 'printButton', text: 'Imprimir',
      title: 'Informe Costo Proveedor',
      exportOptions: {
        columns: [':visible :not(:first-child)']
      }
    }
  ]

  dtTblIncidencia  : any;
  public pqrs : any[] = [];
  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}

  /**
   * Obtener el listado completo de PQR
   * JMM-2018-07-09
   */
  getPqr(){
    let url = this.PATH + '/api/public/pqr';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  filtropqrincial(){
    let url = this.PATH + '/api/public/filtropqrincial';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Obtener un registro por id de una PQR para editar
   * JMM-2018-07-09
   */
  getRegPqr(id:any){
    let url = this.PATH + '/api/public/registropqr/' + id;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Enviar registro de PQR para guardarlo en bd
   * JMM-2018-07-09
   */
  setPqr(pqr:any){
    let url = this.PATH + '/api/public/pqr';
    return this.http.post(url, pqr, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Editar registro de PQR en bd
   * JMM-2018-07-09
   */
  editPqr(pqr:any){
    let identificador;
    //Si llega el id
    if (pqr.id >= '0') {
      identificador = pqr.id;
    }
    //Si llega el pqrid
    if (pqr.pqrid >= '0') {
      identificador = pqr.pqrid;
    }
    let url = this.PATH+'/api/public/pqr/'+identificador;
    return this.http.put(url, pqr, {headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   * Obtener el registro de la PQR para editarlo
   * JMM-2018-07-23
   */
  editRegPqr(id:any){
    let url = this.PATH + '/api/public/pqr/'+id+'/edit';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Enviar registro del archivo PQR para guardarlo en bd
   * JMM-2018-07-09
   */
  setArchivoPqr(archivopqr:any){
    let url = this.PATH + '/api/public/pqrarchivo';
    return this.http.post(url, archivopqr, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Editar registro del archivo PQR para guardarlo en bd
   * JMM-2018-07-09
   */
  editArchivoPqr(archivopqr:any){
    let url = this.PATH+'/api/public/pqrarchivo/'+archivopqr.id;
    return this.http.put(url, archivopqr, {headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   * Obtener listado de incidencias segun filtro
   * JMM-2018-09-10
   */
  getFilroPqr(info){
    info.permiso_vertodaslasincidencias  = (info.permiso_vertodaslasincidencias != '' && info.permiso_vertodaslasincidencias != undefined) ? info.permiso_vertodaslasincidencias : null;
    info.inc_por_dependencia  = (info.especiales_vertodaslasincidencias_por_dependencia != '' && info.especiales_vertodaslasincidencias_por_dependencia != undefined) ? info.especiales_vertodaslasincidencias_por_dependencia : null;
    info.inc_por_usuario_creo  = (info.especiales_vertodas_incidencias_reportadas_por_usuario != '' && info.especiales_vertodas_incidencias_reportadas_por_usuario != undefined) ? info.especiales_vertodas_incidencias_reportadas_por_usuario : null;
    let url = this.PATH + '/api/public/filtros-pqr';
    return this.http.post(url, info ,{headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Obtener parametros para permitir visualizar campos
   * JMM-2018-10-04
   */
  paramCampos(){
    let url = this.PATH + '/api/public/montaje';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Obtener tipo actividades segun equipo
   * CAAA-2018-11-26
   */
  obtenerTipoActividades(pqrid:any){
    let url = this.PATH + '/api/TipoActividadesWeb/'+pqrid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  obtenerActividadesIncidencia(pqrid:any){
    let url = this.PATH + '/api/actividadesincidencia/'+pqrid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  fototercero(terceroid:any){
    let url = this.PATH + '/api/public/fototercero/'+terceroid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Obtener registro de las actividades de los tecnicos registradas en logtiempo
   * JMM-2018-11-29
   */
  listActividadesTecnicosLogtiempo(pqrid){
    let url = this.PATH + '/api/listActividadesTecnicosLogtiempo/'+pqrid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

   /**
   * permite cerrar el las actividades iniciadas desde la web
   * JMM-2018-07-09
   */
  cerrarActividadPqrWeb(data_ActividadesCierre){
    let url = this.PATH + '/api/cerrarActividadPqrWeb';
    return this.http.post(url,data_ActividadesCierre, {headers:this._key.head()}).map( resp => resp.json());
  }

   /**
   * permite listar las actividades iniciadas desde la web
   * CESAR ARIAS-2019-06-26
   */
  getIncidenciasTecnico(tecnicoid){
    let url = this.PATH + '/api/ListTicketAppWeb/'+tecnicoid;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   *permite listar todas las incidencias asignadas a los tecnicos para mostrarlas en el modulo de app web
   * CESAR ARIAS-2019-06-26
   */
  getIncidenciasTecnicoAppWeb(data){
    let url = this.PATH + '/api/ListTicketAppWebProceso';
    return this.http.post(url,data ,{headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   * valida si el cordinador tiene permisos para editar y eliminar actividades desde la web
   *  CESAR-2019-04-02
   */
  validaUasuarioAutorizador(usuarioValidar){
    let url = this.PATH + '/api/validaUasuarioAutorizador';
    return this.http.post(url,usuarioValidar, {headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   * permite cerrar el las actividades iniciadas desde la web
   * JMM-2018-07-09
   */
  editarActividadPqrWeb(data_editActividadesCierre){
    let url = this.PATH + '/api/cerrarActividadPqrWeb/'+data_editActividadesCierre.logtiempoinicio;
    return this.http.put(url,data_editActividadesCierre, {headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   * permite eliminar el las actividades iniciadas desde la web
   * cesar arias -2019-04-01
   */
  eliminarActividad(dataeliminar){
    let url = this.PATH+'/api/eliminarActividadweb';
    return this.http.post(url, dataeliminar, {headers:this._key.head()}).map( resp => resp.json());
  }

   /**
   * permite consultar el ultimo estado de la pepqr de la tabla logtiempo
   * CESAR ARIAS-2019-06-26
   */
  ultimoEstadoPqrLog(pqrid:any,tecnicoid:any){
    let url = this.PATH + '/api/ultimoEstadoPqrLog/'+pqrid+'/'+tecnicoid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

   /**
   * funciaon que permite iniciar ,pausar,cntinuar la actividad desde la web
   * CESAR ARIAS-2019-06-26
   */
  submitAppWeb(datalog){
    let url = this.PATH + '/api/submitAppWeb';
    return this.http.post(url,datalog, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Crear INC a partir de otra INC en bd
   * JMM-2019-03-19
   */
  dupliquePqr(pqr:any){
    let url = this.PATH+'/api/public/duplicarpqr';
    return this.http.post(url, pqr, {headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   * valida si la incidencia tiene movimientos para bloquear campos en la edición incidencias
   * CESAR ARIAS-2019-03-22
   */
  validarMoviPqr(pqr:any){
    let url = this.PATH+'/api/public/validarMoviPqr/'+ pqr;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }

   /**
   * olista todas las operacionesde tiempo del equipo inventariado
   * CESAR ARIAS -2019-05-07
   */
  operacionesTiempo(itemequipoid:any){
    let url = this.PATH+'/api/public/operacionesTiempo/'+ itemequipoid;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }

  operacionesConsumo(itemequipoid:any){
    let url = this.PATH+'/api/public/operacionesConsumo/'+ itemequipoid;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   * Retorna listado de incidencias asociadas a un tercero
   * JMM-2019-07-06
   */
  listadopqrportercero(terceroid:any, sucursalid:any){
    let url = this.PATH+'/api/public/listadopqrportercero/'+terceroid+'/'+sucursalid;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }

   /**
   * validad ticketal momento de crear la incidencia
   * CESAR ARIAS -2019-08-27
   */
  validartickect(ticket:any,pqrid:any){
    let url = this.PATH+'/api/public/validartickect/'+ ticket +'/'+ pqrid;
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   * eliminar pqr
   * CESAR ARIAS -2019-08-27
   */
  destroyEvidencia(data:any){
    let url = this.PATH+'/api/public/eliminarpqr';
    return this.http.post(url,data,{headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   * Obtener un registro por itemequipoid de un responsable del tercero responsable de la incidencia
   * CESAR AUGUSTO ARIAS-2020-07-29
   */
  TerceroResponsableInventa(itemequipoid:any){
    let url = this.PATH + '/api/public/TerceroResponsableInventa/' + itemequipoid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Obtener registros de componentes de
   * CESAR AUGUSTO ARIAS-2020-07-29
   */
  GetComponentesEquipo(itemequipoid:any){
    let url = this.PATH + '/api/public/GetComponentesEquipo/' + itemequipoid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Obtener registros de subcomponentes de ficha servicio
   * CESAR AUGUSTO ARIAS-2020-07-29
   */
  GetSubComponentesEquipo(equipoid:any,componenteid:any,fichatecnicaservicioid:any){
    let url = this.PATH + '/api/public/GetSubComponentesEquipo/' + equipoid + '/' + componenteid + '/' + fichatecnicaservicioid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  proveedorFicha(itemequipoid:any){
    let url = this.PATH + '/api/public/proveedorFicha/'+itemequipoid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  validaexistencia(proveedorid:any){
    let url = this.PATH + '/api/public/validaexistencia/'+proveedorid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  datosfiltrosGenerales(){
    let url = this.PATH + '/api/public/datosfiltrosGenerales';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Obtener listado de incidencias para el modulo de asignación técnicos multiples
   * caa-2021-03-24
   */
  filtrosAsignacionMultipleTecnico(info){
    let url = this.PATH + '/api/public/filtrosAsignacionMultipleTecnico';
    return this.http.post(url, info ,{headers:this._key.head()}).map(resp => resp.json());
  }

  tecniosAsignados(pqrid:any){
    let url = this.PATH+'/api/public/tecniosAsignados';
    return this.http.post(url,pqrid,{headers:this._key.head()}).map( resp => resp.json());
  }

  /**
   * Enviar registros
   */
  updateMultipleTecnicos(tratamientopqr:any){
    let url = this.PATH + '/api/public/updateMultipleTecnicos';
    return this.http.post(url, tratamientopqr, {headers:this._key.head()}).map(resp => resp.json());
  }

  updateIndividualTecnicos(tratamientopqr:any){
    let url = this.PATH + '/api/public/updateIndividualTecnicos';
    return this.http.post(url, tratamientopqr, {headers:this._key.head()}).map(resp => resp.json());
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/pqr/pqr.service.ts